import React from 'react';
import { IoCheckmarkCircleOutline } from 'react-icons/io5';

const steps = ['Draft', 'Completed', 'Finalized'];

const ProgressStepper = ({ currentStep = 0 }) => (
  <div className="narrative-stepper">
    {steps.map((step, index) => (
      <React.Fragment key={step}>
        <div className="narrative-step">
          <div className={`narrative-step-circle ${index < currentStep ? 'done' : ''} ${index === currentStep ? 'active' : ''}`}>
            {index < currentStep ? <IoCheckmarkCircleOutline /> : index + 1}
          </div>
          <div className={index <= currentStep ? 'text-dark' : 'text-muted'}>{step}</div>
        </div>
        {index < steps.length - 1 && (
          <div className={`narrative-step-line ${index < currentStep ? 'done' : ''}`} />
        )}
      </React.Fragment>
    ))}
  </div>
);

export default ProgressStepper;
